import React from "react";

const teamSponsors = [
  {
    team: "Mumbai Indians",
    sponsor: "Lauritz Knudsen",
    logo: "https://m.media-amazon.com/images/I/61NMAWvk-5L._AC_UF350,350_QL80_.jpg",
  },
  {
    team: "Royal Challengers Bengaluru",
    sponsor: "Nothing",
    logo: "https://m.media-amazon.com/images/I/71t-JnnQaWL._AC_UF1000,1000_QL80_.jpg",
  },
  {
    team: "Chennai Super Kings",
    sponsor: "Etihad Airways",
    logo: "https://content.r9cdn.net/rimg/dimg/91/9e/e3e7b5e1-al-EY-55c4cb79.jpg?width=1200&height=630&xhint=341&yhint=168&crop=true",
  },
  {
    team: "Kolkata Knight Riders",
    sponsor: "VIDA Powered by Hero",
    logo: "https://cdn.bikedekho.com/processedimages/hero-electric/scooter/source/scooter66f151afc7f19.jpg",
  },
  {
    team: "Delhi Capitals",
    sponsor: "Hero Fincorp",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a2/Hero_FinCorp_Logo_New_Final_2013_Vertical_Wiki.png",
  },
  {
    team: "Sunrisers Hyderabad",
    sponsor: "Shree Cement",
    logo: "https://5.imimg.com/data5/MT/YL/YB/SELLER-1735247/ppc-shree-cement.jpg",
  },
  {
    team: "Punjab Kings",
    sponsor: "CP Plus",
    logo: "https://m.media-amazon.com/images/I/51aDwuCqdHL.jpg",
  },
  {
    team: "Rajasthan Royals",
    sponsor: "Waaree Energies",
    logo: "https://cms-resources.groww.in/uploads/TAX_SLAB_2025_04_22_T114012_998_11zon_e9ede39c3c.jpg",
  },
  {
    team: "Gujarat Titans",
    sponsor: "Birla Estates",
    logo: "https://media.licdn.com/dms/image/v2/D4D0BAQGwJkXqOsKaeg/company-logo_200_200/company-logo_200_200/0/1708842521343/birla_estates_logo?e=2147483647&v=beta&t=52XG55xTAh_ZKd9NZ3v4YCrdCmThqG2DePbLuyX9G08",
  },
  {
    team: "Lucknow Super Giants",
    sponsor: "JK Super Cement",
    logo: "https://images.jdmagicbox.com/quickquotes/images_main/jk-super-cement-2226587001-udzo0ndj.jpg",
  },
];

const officialSponsors = [
  {
    category: "Title Sponsor",
    sponsors: [
      {
        name: "Tata",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-tata-logo.png",
      },
    ],
  },
  {
    category: "Premier Partners",
    sponsors: [
      {
        name: "Angel One",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-angelone-logo.png",
      },
      {
        name: "RuPay",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-rupay-logo.png",
      },
      {
        name: "Google AI",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-googleai-logo.png",
      },
    ],
  },
  {
    category: "Umpire Partner",
    sponsors: [
      {
        name: "Wonder Cement",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-wondercement-logo.png",
      },
    ],
  },
  {
    category: "Strategic Timeout Partner",
    sponsors: [
      {
        name: "CEAT",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-ceat-logo.png",
      },
    ],
  },
  {
    category: "Good Times Partner",
    sponsors: [
      {
        name: "Pepsi",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSusWK0FB7VdL_goTaTeRcelppkLjnT8VrRNg&s",
      },
    ],
  },
  {
    category: "Official Broadcaster",
    sponsors: [
      {
        name: "Star Sports",
        logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Star_Sports_1_HD.png/960px-Star_Sports_1_HD.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail",
      },
    ],
  },
  {
    category: "Official Digital Streaming Partner",
    sponsors: [
      {
        name: "JioCinema",
        logo: "https://www.iplt20.com/assets/images/new-sponsor-jiohotstar-logo.png",
      },
    ],
  },
];

const Sponsors = () => {
  return (
    <div className="px-4 py-8 min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="mx-auto max-w-6xl">
        <h1 className="mb-10 text-4xl font-bold text-center text-indigo-900">
          IPL Sponsors
        </h1>

        {/* Official IPL Sponsors */}
        <section className="mb-12">
          <h2 className="inline-block pb-2 mb-8 text-2xl font-semibold text-center text-indigo-800 border-b-4 border-indigo-500">
            Official IPL Sponsors
          </h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {officialSponsors.map((item, index) => (
              <div
                key={index}
                className="p-6 bg-white rounded-xl shadow-lg transition-shadow duration-300 hover:shadow-xl"
              >
                <h3 className="mb-4 text-lg font-bold text-center text-indigo-700">
                  {item.category}
                </h3>
                <div className="flex flex-wrap gap-4 justify-center">
                  {item.sponsors.map((sponsor, idx) => (
                    <div
                      key={idx}
                      className="bg-white px-6 py-4 rounded-xl shadow-md flex flex-col items-center justify-center min-w-[150px] min-h-[120px]"
                    >
                      {sponsor.logo ? (
                        <img
                          src={sponsor.logo}
                          alt={sponsor.name}
                          className="max-w-full max-h-[60px] object-contain"
                        />
                      ) : (
                        <div className="text-lg font-bold text-indigo-700">
                          {sponsor.name}
                        </div>
                      )}
                      <p className="mt-2 text-sm text-gray-600">
                        {sponsor.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Team Sponsors */}
        <section>
          <h2 className="inline-block pb-2 mb-8 text-2xl font-semibold text-center text-indigo-800 border-b-4 border-indigo-500">
            Team Sponsors
          </h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {teamSponsors.map((item, index) => (
              <div
                key={index}
                className="flex flex-col gap-4 p-6 bg-white rounded-xl shadow-lg transition-shadow duration-300 hover:shadow-xl"
              >
                <h3 className="text-lg font-bold text-gray-800">{item.team}</h3>
                <div className="flex flex-col gap-3 items-center">
                  {item.logo ? (
                    <img
                      src={item.logo}
                      alt={item.sponsor}
                      className="max-w-full max-h-[80px] object-contain"
                    />
                  ) : (
                    <div className="text-lg font-bold text-indigo-700">
                      {item.sponsor}
                    </div>
                  )}
                  <p className="font-medium text-indigo-600">{item.sponsor}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Sponsors;
